import en from './en'
import es from './es'

export const localeKeys = ['en', 'es'] as const

export type Locale = (typeof localeKeys)[number]

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type LocaleMessages = any

export const flatten = (obj: LocaleMessages, prefix: string = '') => {
	const flattened: Record<string, string> = {}

	Object.keys(obj).forEach((key) => {
		const value = obj[key]
		const prefixedKey = prefix ? `${prefix}.${key}` : key

		if (typeof value === 'object' && value !== null) {
			Object.assign(flattened, flatten(value, prefixedKey))
		} else {
			flattened[prefixedKey] = value
		}
	})

	return flattened
}

/**
 * Validates if a string is a supported locale and serves as a type guard.
 *
 * @param locale - The locale string to validate (e.g., 'en', 'es')
 * @returns True if the locale is supported, false otherwise
 *
 * @example
 * ```typescript
 * const userLocale = 'en'
 * if (isValidLocale(userLocale)) {
 *   // userLocale is now typed as Locale
 *   console.log('Valid locale:', userLocale)
 * }
 * ```
 */
export const isValidLocale = (locale: string): locale is Locale => {
	return localeKeys.includes(locale as Locale)
}

const locales: Record<Locale, Record<string, LocaleMessages>> = {
	en: flatten(en),
	es: flatten(es),
}

export const defaultLocale = 'en'
export default locales
